import React from "react";
// style components
import { Modal, Form, Input, Button, Select } from "antd";
// models
import { ExperienciaModel, AreasModel, initialValuesExperienciasmodel } from "../../../models/JuradosModel/agregarExpericiencia.model";
// hooks
import { useAgregarExperienciaJurado } from '../../../hooks/useAgregarExperienciaJurado'
import DocumentInput from "../../../utils/DocumentInput";
import DocumentosService  from "../../../api/Documentos/api-documentos";


// models
interface IProps {
  experiencia: ExperienciaModel;
  setExperiencia: any;
  experiencias: Array<ExperienciaModel>;
  setExperiencias: any;
  modal: boolean;
  setModal: any;
  guardarCambios: any;
  limpiarcampos: any;
  areas: Array<AreasModel>;
  setAreas: any
  indexExperiencia: number;
}

export const ModaleditarExperiencias: React.FC<IProps> = (props: IProps) => {
  const { fileInputRef } = useAgregarExperienciaJurado();

  const fields = [
    { name: "nombre_convocatoria", value: props.experiencia.nombre_convocatoria },
    { name: "entidad", value: props.experiencia.entidad },
    { name: "anio", value: props.experiencia.anio },
    { name: "ciudad", value: props.experiencia.ciudad },
    { name: "area", value: props.experiencia.area },
    { name: "documento", value: props.experiencia.documento }
  ];

  const onCancel = () => {
    props.setExperiencia(initialValuesExperienciasmodel);
    props.setModal(false)
  }

  const guardarArchivoeditar = async (e: any) => {
    if (e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return props.setExperiencia({ ...props.experiencia, documento: data.data });
  }
  };

  return (
    <Modal
      title={
        <span className="font-family-Montserrat-Bold">
          Editar experiencia como jurado -{" "}
          <span className="font-color-DB2828 font-size-10px font-family-Montserrat-Regular">
            Todos los campos son obligatorios
          </span>
        </span>
      }
      // style={{ top: 60 }}
      width={window.innerWidth * 0.9}
      visible={props.modal}
      onCancel={onCancel}
      footer={[
        <Button key="B_CancelarModalEditarExperiencia" className="button-gray-ghost" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="B_LimpiarModalEditarExperiencia" style={{ marginBottom: '20px' }} className="button-azul-ghost font-size-12px" onClick={() => props.limpiarcampos()}>
          Limpiar campos
        </Button>,
        <Button key="B_GuardarModalEditarExperiencia" className="button-azul-radius" form="modalEditarExperiencia" htmlType="submit">
          Guardar cambios
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
      }}
    >
      <Form
        size="large"
        name="modalEditarExperiencia"
        onFinish={props.guardarCambios}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...props.experiencia };
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          props.setExperiencia(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre de la convocatoria
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_convocatoria"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Entidad
            </span>
            <Form.Item className="no-margin" name="entidad" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Año
            </span>
            <Form.Item className="no-margin" name="anio" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Ciudad
            </span>
            <Form.Item className="no-margin" name="ciudad" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Expresiones
            </span>
            <Form.Item className="no-margin" name="area" rules={[{ required: true, message: "Campo obligatorio" }]}>
              <Select style={{ width: "100%" }} placeholder="C.C.">
                {props.areas.map(({ id_area, nombre_area }) => (
                  <Select.Option key={id_area} value={id_area}>
                    {nombre_area}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Anexar documento???
            </span>
            <Form.Item className="no-margin" name="documento" rules={[{ required: true, message: "Documento obligatorio" }]}>
              <DocumentInput
                doc={props.experiencia.documento}
                fileInputRef={fileInputRef}
                ancho_btn={30}
                on_change={(e) => {
                  guardarArchivoeditar(e);
                  e.target.value = ""
                }}
                onDelete={() => {
                  props.setExperiencia({
                    ...props.experiencia,
                    documento: "",
                  });
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
